<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Importazione file</h1>
      </div>
      <p class="editor-lead">Importa regioni, province e città da un file Excel ISTAT.</p>
    </header>

    <section class="editor-panel">
      <h2>Regioni, province e città</h2>
      <p class="panel-text">
        Il file di riferimento è disponibile su
        <a href="https://www.istat.it/it/archivio/6789" target="_blank" rel="noopener noreferrer">
          https://www.istat.it/it/archivio/6789
        </a>.
      </p>
      <div class="file-note">
        <strong>Formato atteso</strong>
        <span>La prima riga contiene l'intestazione. Le colonne utilizzate sono 6, 10, 11, 14 e 19 (indice da zero).</span>
      </div>

      <div class="upload-row">
        <input id="fileUpload" type="file" accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (change)="uploadFiles($event)" #fileUpload>
        <button class="editor-save" type="button" (click)="fileUpload.click()">
          <i class="bi bi-upload" aria-hidden="true"></i>
          Importa file Excel
        </button>
      </div>
    </section>
  </div>
</div>
